module.exports = __webpack_public_path__ + "static/media/ambiance.09d1a7fa.mp3";